export const METHODS_REQUIRING_PASSPHRASE_CHECK = [
  'evmGetAddress',
  'evmGetPublicKey',
  'evmSignMessage',
  'evmSignTransaction',
  'evmSignTypedData',
  'btcGetAddress',
  'btcGetPublicKey',
  'btcSignMessage',
  'btcSignTransaction',
  'cosmosGetAddress',
  'cosmosGetPublicKey',
  'cosmosSignTransaction',
  'starcoinGetAddress',
  'starcoinGetPublicKey',
  'starcoinSignMessage',
  'starcoinSignTransaction',
  'cardanoGetAddress',
  'cardanoGetPublicKey',
  'cardanoSignMessage',
  'cardanoSignTransaction',
  'solGetAddress',
  'solSignTransaction',
  'aptosGetAddress',
  'aptosGetPublicKey',
  'aptosSignMessage',
  'aptosSignTransaction',
  'nearGetAddress',
  'nearSignTransaction',
  'polkadotGetAddress',
  'polkadotSignTransaction',
  'stellarGetAddress',
  'stellarSignTransaction',
  'xrpGetAddress',
  'xrpSignTransaction',
  'tronGetAddress',
  'tronSignMessage',
  'tronSignTransaction',
  'tonGetAddress',
  'tonSignMessage',
  'tonSignProof',
  'suiGetAddress',
  'suiGetPublicKey',
  'suiSignMessage',
  'suiSignTransaction',
  'filecoinGetAddress',
  'filecoinSignTransaction',
  'confluxGetAddress',
  'confluxSignMessage',
  'confluxSignTransaction',
  'kaspaGetAddress',
  'kaspaSignTransaction',
  'nervosGetAddress',
  'nervosSignTransaction',
  'nemGetAddress',
  'nemSignTransaction',
  'nexaGetAddress',
  'nexaSignTransaction',
  'algoGetAddress',
  'algoSignTransaction',
  'dnxGetAddress',
  'dnxSignTransaction',
  'scdoGetAddress',
  'scdoSignMessage',
  'scdoSignTransaction',
  'alephiumGetAddress',
  'alephiumSignMessage',
  'alephiumSignTransaction',
  'nostrGetPublicKey',
  'nostrSignEvent',
  'nostrSignSchnorr',
  'nostrEncryptMessage',
  'nostrDecryptMessage',
];
